import { motion } from 'framer-motion'
import { ArrowLeft } from 'lucide-react'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { GestorEquipeDetailContent } from '@/components/Gestores/GestorEquipeDetailContent'
import { Button } from '@/components/ui/Button'
import { useGestorEquipeDetailPage } from '@/hooks/useGestorEquipeDetailPage'
import { toast } from 'sonner'

export default function GestorEquipeDetailPage() {
  const {
    detail,
    loading,
    error,
    goBack,
    submitFerias,
    createFeedback,
    updateFeedback,
    liberarFeedback,
    deleteFeedback,
    initialTab,
  } = useGestorEquipeDetailPage()

  const handleSubmitFerias = async (form: Parameters<typeof submitFerias>[0]) => {
    try {
      await submitFerias(form)
    } catch {
      toast.error('Falha ao registrar férias')
    }
  }

  const handleDeleteFeedback = async (feedbackId: string) => {
    try {
      await deleteFeedback(feedbackId)
    } catch {
      toast.error('Falha ao excluir registro')
    }
  }

  return (
    <DashboardLayout
      title={detail?.nomeCompleto ?? 'Profissional PJ'}
      actions={
        <Button variant='secondary' size='sm' type='button' onClick={goBack}>
          <ArrowLeft size={14} />
          Voltar à equipe
        </Button>
      }
    >
      {error && (
        <div className='mb-4 rounded-lg border border-danger/30 bg-danger/5 px-4 py-3 text-sm text-danger'>
          {error}
        </div>
      )}

      {loading ? (
        <div className='glass-card flex justify-center py-16'>
          <div className='h-8 w-8 animate-spin rounded-full border-2 border-accent border-t-transparent' />
        </div>
      ) : detail ? (
        <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}>
          <GestorEquipeDetailContent
            detail={detail}
            initialTab={initialTab}
            onSubmitFerias={handleSubmitFerias}
            onCreateFeedback={async (tipo, payload) => {
              try {
                await createFeedback(tipo, payload)
              } catch {
                toast.error('Falha ao salvar feedback')
              }
            }}
            onUpdateFeedback={async (id, payload) => {
              try {
                await updateFeedback(id, payload)
              } catch {
                toast.error('Falha ao atualizar feedback')
              }
            }}
            onLiberarFeedback={async (id) => {
              try {
                await liberarFeedback(id)
              } catch {
                toast.error('Falha ao liberar feedback')
              }
            }}
            onDeleteFeedback={handleDeleteFeedback}
          />
        </motion.div>
      ) : null}
    </DashboardLayout>
  )
}
